import { userInfoVar } from "../utils/ApolloCache";
import Header from "./Header";
import CompanyDropdown from "./navigation/CompanyDropdown";
import UserDropdown from "./navigation/UserDropdown";
import React from "react";

type DefaultHeaderProps = {
  setShowMobileNav: (show: boolean) => void;
  showMobileNav: boolean;
};

export const DefaultHeader = ({ setShowMobileNav, showMobileNav }: DefaultHeaderProps) => {
  const usersCompanyIds = userInfoVar()?.companyIds;

  return (
    <Header
      onMobileNavigationClick={() => {
        setShowMobileNav(!showMobileNav);
      }}
      render={() => (
        <>
          {usersCompanyIds && <CompanyDropdown usersCompanyIds={usersCompanyIds} />}
          <UserDropdown />
        </>
      )}
    />
  );
};
